<div class="hardware-settings-container">
    <div class="setting-wrapper" #section>
        <div class="setting-title">
            {{ 'system-specifications.system.title' | translate }}
        </div>
        <div class="table-container">
            <div class="table-row table-header">
                <div class="table-cell" style="--col-width: 2">
                    {{ 'system-specifications.header.item' | translate }}
                </div>
                <div class="table-cell" style="--col-width: 3">
                    {{ 'system-specifications.header.model' | translate }}
                </div>
                <div class="table-cell" style="--col-width: 1">
                    {{ 'system-specifications.header.qty' | translate }}
                </div>
            </div>
            <div class="table-row">
                <div class="table-cell bold-text" style="--col-width: 2">FCU</div>
                <div class="table-cell" style="--col-width: 3">
                    {{ fcuData.model }}
                </div>
                <div class="table-cell" style="--col-width: 1">
                    {{ fcuData.qty }}
                </div>
            </div>
            <div class="table-row">
                <div class="table-cell column-cell" style="--col-width: 2">
                    <div class="bold-text">
                        {{ 'system-specifications.hub.title' | translate }}
                    </div>
                    <div class="row-subtitle">
                        {{ 'system-specifications.hub-row.subtitle' | translate }}
                    </div>
                </div>
                <div class="table-cell" style="--col-width: 3">
                    {{ hubData.model }}
                </div>
                <div class="table-cell" style="--col-width: 1">
                    <ng-container *ngIf="userCanEdit">
                        <app-input-with-error
                            [inputValue]="hardwareSpecification.HUB.qty.toString()"
                            (onInputUpdated)="handleHubInputChange($event)"
                            [maxlength]="3"
                            [showLegend]="false"
                            [isNumberInput]="true">
                        </app-input-with-error>
                    </ng-container>
                    <ng-container *ngIf="!userCanEdit">
                        {{ initialNumberOfHub }}
                    </ng-container>
                </div>
            </div>
            <div class="table-row">
                <div class="table-cell bold-text" style="--col-width: 2">iEdge</div>
                <div class="table-cell" style="--col-width: 3">
                    {{ iEdgeData.model }}
                </div>
                <div class="table-cell" style="--col-width: 1">
                    {{ iEdgeData.qty }}
                </div>
            </div>
        </div>

        <div class="table-container simple-table">
            <div class="table-row table-header">
                <div class="table-cell" style="--col-width: 4">
                    {{ 'system-specifications.header.item' | translate }}
                </div>
                <div class="table-cell" style="--col-width: 1">
                    {{ 'system-specifications.header.setting' | translate }}
                </div>
            </div>
            <div class="simple-table-wrapper">
                <div class="thin-row">
                    <div class="table-cell bold-text left-text" style="--col-width: 5">EAP</div>
                </div>
                <div class="simple-row">
                    <div class="table-cell" style="--col-width: 4">
                        {{ 'system-specifications.eap.display' | translate }}
                    </div>
                    <div class="table-cell" style="--col-width: 1">
                        {{ eapData.display }}
                    </div>
                </div>
                <div class="simple-row">
                    <div class="table-cell" style="--col-width: 4">
                        {{ 'system-specifications.eap.class' | translate }}
                    </div>
                    <div class="table-cell" style="--col-width: 1">
                        {{ eapClass | translate }}
                    </div>
                </div>
                <div class="simple-row" style="border-radius: 0px 0px 4px 4px">
                    <div class="table-cell" style="--col-width: 4">
                        {{ 'system-specifications.eap.fire-alarm' | translate }}
                    </div>
                    <div class="table-cell end-align" style="--col-width: 1">
                        <ng-container *ngTemplateOutlet="booleanIndicator; context: { value: eapData.fireAlarm }" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="setting-wrapper" #section>
        <div class="setting-title">
            {{ 'system-specifications.OPS.title' | translate }}
        </div>
        <div class="table-container extra-long-table">
            <div class="table-row table-header">
                <div class="table-cell" style="--col-width: 1">
                    {{ 'system-specifications.header.number' | translate }}
                </div>
                <div class="table-cell" style="--col-width: 3">
                    {{ 'system-specifications.header.location' | translate }}
                </div>
                <div class="table-cell" style="--col-width: 3">
                    {{ 'system-specifications.header.model' | translate }}
                </div>
                <div class="table-cell" style="--col-width: 2">
                    {{ 'system-specifications.header.mount-type' | translate }}
                </div>
                <div class="table-cell" style="--col-width: 2">
                    {{ 'system-specifications.header.color' | translate }}
                </div>
                <div class="table-cell" style="--col-width: 2">
                    {{ 'system-specifications.header.emc' | translate }}
                </div>
                <div class="table-cell" style="--col-width: 2">
                    {{ 'system-specifications.header.sunshade' | translate }}
                </div>
                <div class="table-cell center-text" style="--col-width: 2">
                    {{ 'system-specifications.header.ethernet' | translate }}
                </div>
            </div>
            <div *ngFor="let opsUnit of hardwareSpecification.OPS" class="table-row">
                <div class="table-cell" style="--col-width: 1">
                    {{ opsUnit.index }}
                </div>
                <div class="table-cell" style="--col-width: 3">
                    <mat-icon class="indicator-icon" svgIcon="location"></mat-icon>
                    <div>{{ opsUnit.location }}</div>
                </div>
                <div class="table-cell" style="--col-width: 3">
                    {{ opsUnit.model }}
                </div>
                <div class="table-cell" style="--col-width: 2">
                    {{ getMountTypeString(opsUnit) | translate }}
                </div>
                <div class="table-cell" style="--col-width: 2">
                    {{ opsUnit.color }}
                </div>
                <div class="table-cell" style="--col-width: 2">
                    <ng-container *ngTemplateOutlet="booleanIndicator; context: { value: opsUnit.EMC }" />
                </div>
                <div class="table-cell" style="--col-width: 2">
                    <ng-container *ngTemplateOutlet="booleanIndicator; context: { value: opsUnit.sunshade }" />
                </div>
                <div class="table-cell center-text" style="--col-width: 2">
                    <ng-container
                        *ngTemplateOutlet="booleanIndicator; context: { value: opsUnit.ethernetExtraLength }" />
                </div>
            </div>
        </div>
    </div>
    <div class="setting-wrapper" #section>
        <div class="setting-title">
            {{ 'system-specifications.input.title' | translate }}
        </div>
        <div class="table-container">
            <div class="table-row table-header">
                <div class="table-cell" style="--col-width: 2">
                    {{ 'system-specifications.header.device' | translate }}
                </div>
                <div class="table-cell" style="--col-width: 3">
                    {{ 'system-specifications.header.model' | translate }}
                </div>
                <div class="table-cell" style="--col-width: 1">
                    {{ 'system-specifications.header.qty' | translate }}
                </div>
            </div>
            <div class="table-row">
                <div class="table-cell bold-text" style="--col-width: 2">
                    {{ 'system-specifications.keyboard.title' | translate }}
                </div>
                <div class="table-cell" style="--col-width: 3">
                    {{ keyboardData.model }}
                </div>
                <div class="table-cell" style="--col-width: 1">
                    <ng-container *ngIf="userCanEdit">
                        <app-system-setting-dropdown
                            [itemList]="inputDeviceOptions"
                            [dropdownWidth]="'100%'"
                            [isDropdownBelow]="true"
                            [value]="hardwareSpecification.Keyboard.qty"
                            (onInputChange)="handleKeyboardChange($event)">
                        </app-system-setting-dropdown>
                    </ng-container>
                    <ng-container *ngIf="!userCanEdit">
                        {{ initialNumberOfKeyboards }}
                    </ng-container>
                </div>
            </div>
            <div class="table-row">
                <div class="table-cell bold-text" style="--col-width: 2">
                    {{ 'system-specifications.trackball.title' | translate }}
                </div>
                <div class="table-cell" style="--col-width: 3">
                    {{ trackballData.model }}
                </div>
                <div class="table-cell" style="--col-width: 1">
                    <ng-container *ngIf="userCanEdit">
                        <app-system-setting-dropdown
                            [itemList]="inputDeviceOptions"
                            [dropdownWidth]="'100%'"
                            [isDropdownBelow]="true"
                            [value]="hardwareSpecification.Trackball.qty"
                            (onInputChange)="handleTrackballChange($event)">
                        </app-system-setting-dropdown>
                    </ng-container>
                    <ng-container *ngIf="!userCanEdit">
                        {{ initialNumberOfTrackballs }}
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div class="setting-wrapper" #section>
        <div class="setting-title">
            {{ 'system-specifications.FU.title' | translate }}
        </div>
        <div class="table-container">
            <div class="table-row table-header">
                <div class="table-cell" style="--col-width: 2">
                    {{ 'system-specifications.header.model' | translate }}
                </div>
                <div class="table-cell" style="--col-width: 3">
                    {{ 'system-specifications.header.location' | translate }}
                </div>
                <div class="table-cell" style="--col-width: 1">
                    {{ 'system-specifications.header.qty' | translate }}
                </div>
            </div>
            <div *ngFor="let fuUnit of hardwareSpecification.FU" class="table-row">
                <div class="table-cell" style="--col-width: 2">
                    {{ fuUnit.model }}
                </div>
                <div class="table-cell" style="--col-width: 3">
                    {{ getFuLocations(fuUnit.locations) }}
                </div>
                <div class="table-cell" style="--col-width: 1">
                    {{ fuUnit.qty }}
                </div>
            </div>
        </div>
    </div>
    <div class="setting-wrapper" #section>
        <div class="setting-title">
            {{ 'system-specifications.slots.title' | translate }}
        </div>
        <div class="table-container">
            <div class="table-row table-header">
                <div class="table-cell bold-text left-text" style="--col-width: 5">
                    {{ 'system-specifications.header.PT' | translate }}
                </div>
            </div>
            <div class="simple-table-wrapper">
                <ng-container *ngIf="hasPt100Wire">
                    <div class="simple-row" style="border-radius: 4px 4px 0px 0px">
                        <div class="table-cell" style="--col-width: 4">
                            {{ 'system-specifications.PT.wiring' | translate }}
                        </div>
                        <div class="table-cell" style="--col-width: 1">
                            {{ pt100Wrire | translate }}
                        </div>
                    </div>

                    <div class="simple-row" style="border-radius: 0px 0px 4px 4px">
                        <div class="table-cell" style="--col-width: 4">
                            {{ 'system-specifications.PT.resistance' | translate }}
                        </div>
                        <div class="table-cell" style="--col-width: 1">
                            {{ PT100Resitance | translate }}
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="!hasPt100Wire">
                    <div class="empty-ptwire-container">
                        {{ 'system-specifications.PT.empty' | translate }}
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>

<app-anchor-menu
    [sectionList]="sectionsList"
    [currentSectionIndex]="currentSectionIndex"
    (onSelectSection)="handleScrollSection($event)"></app-anchor-menu>

<ng-template #booleanIndicator let-value="value">
    <div class="indicator-container" [class.trueIndicator]="value" [style.fill]="value ? '#D9D9D9' : '#546e7a'">
        <mat-icon class="indicator-icon" [svgIcon]="value ? 'check' : 'close'"></mat-icon>
        <div class="indicator-text" [style.color]="value ? '#185d2d' : '#546e7a'">
            {{ value ? ('dlg.yes' | translate) : ('dlg.no' | translate) }}
        </div>
    </div>
</ng-template>
